/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Pipe, PipeTransform} from '@angular/core';

import {formatLocaleNumber} from '../locale/locale-number-format';
import {AppLocaleService} from '../locale/app-locale.service';

@Pipe({
  standalone: true,
  name: 'localeNumber',
  pure: false
})
export class LocaleNumberPipe implements PipeTransform {
  constructor(private readonly appLocale: AppLocaleService) {
  }

  transform(value: number | string | null | undefined, digitsInfo?: string): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return formatLocaleNumber(value, digitsInfo, this.appLocale.getLocaleId());
  }
}
